module.exports = wp.richText;